import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

type ImpersonateState = {
  impersonatedShop: string | null
  setImpersonatedShop: (shop: string | null) => void
  clearImpersonatedShop: () => void
  hasLoaded: boolean
  setHasLoaded: (hasLoaded: boolean) => void
}

export const useImpersonateStore = create<ImpersonateState>()(
  persist(
    (set, get) => ({
      impersonatedShop: null,
      setImpersonatedShop: (shop: string | null) => set({ impersonatedShop: shop }),
      clearImpersonatedShop: () => set({ impersonatedShop: null }),
      hasLoaded: false,
      setHasLoaded: (hasLoaded: boolean) => set({ hasLoaded: hasLoaded }),
    }),
    {
      name: 'aiod-impersonate-storage',
      storage: typeof window !== 'undefined' ? createJSONStorage(() => localStorage) : undefined,
      onRehydrateStorage: () => (state) => {
        state?.setHasLoaded(true)
      },
    }
  )
)
